import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Input from "components/Elements/Input";
import { saveAgent, clearSavedAgent } from "actions/agents";
import { getTrainingWorkflows, getInferenceWorkflows } from "actions/workflows";
import ErrorField from "components/ErrorField";

const AddAgentModal = NiceModal.create(({ agent = {} }) => {
  const dispatch = useDispatch();
  const { savedAgent, saving } = useSelector((state) => state.agents);
  const { trainingWorkflows, inferenceWorkflows } = useSelector(
    (state) => state.workflows
  );
  const modal = useModal();

  const hide = (e) => {
    e.stopPropagation();
    dispatch(clearSavedAgent());
    modal.remove();
  };

  const cloneAgent = (agent) => {
    const u = {
      id: "",
      public_id: "",
      name: "",
      description: "",
      introduction: "",
      identity: "",
    };
    Object.keys(agent).forEach((key) => {
      u[key] = agent[key];
    });
    return u;
  };

  const [formErrors, setFormErrors] = useState({});
  const [localAgent, setLocalAgent] = useState(cloneAgent(agent));

  useEffect(() => {
    if (!trainingWorkflows) {
      dispatch(getTrainingWorkflows());
    }
    // eslint-disable-next-line
  }, [trainingWorkflows]);

  useEffect(() => {
    if (!inferenceWorkflows) {
      dispatch(getInferenceWorkflows());
    }
    // eslint-disable-next-line
  }, [inferenceWorkflows]);

  useEffect(() => {
    console.log("SAVED AGENT: ", savedAgent);
    if (savedAgent) {
      setLocalAgent(cloneAgent(savedAgent));
    }
  }, [savedAgent]);

  const handleChange = ({ target }) => {
    const u = { ...localAgent };
    u[target.name] = target.value;
    setLocalAgent(u);
  };

  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    console.log("localAgent: ", localAgent);
    const nameValid = localAgent.name && localAgent.name.length > 0;
    errors.name = nameValid ? "" : " is required";

    console.log("errors: ", errors);
    setFormErrors(errors);

    return nameValid;
  };

  const save = () => {
    console.log("save agent: ", localAgent);
    if (validateFields()) {
      dispatch(saveAgent(localAgent));
    }
  };

  return (
    <>
      <div className="w-6/12 force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">
                {agent.id ? "Edit Agent" : "Add Agent"}
              </h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative p-6 flex-auto ">
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <label>ID</label>
                <Input
                  label="ID"
                  placeholder="ID"
                  name="id"
                  value={localAgent.id ?? ""}
                  disabled
                />
                <label>Public ID</label>
                <Input
                  label="Public ID"
                  placeholder="Public ID"
                  name="public_id"
                  value={localAgent.public_id ?? ""}
                  disabled
                />
                <label>
                  Name <ErrorField>{formErrors.name}</ErrorField>
                </label>
                <Input
                  label="Name"
                  placeholder="Name"
                  name="name"
                  value={localAgent.name ?? ""}
                  onChange={handleChange}
                />
                <label>
                  Description <ErrorField>{formErrors.description}</ErrorField>
                </label>
                <Input
                  type="textarea"
                  label="Description"
                  placeholder="Description"
                  name="description"
                  value={localAgent.description ?? ""}
                  onChange={handleChange}
                />
                <label>
                  Introduction{" "}
                  <ErrorField>{formErrors.introduction}</ErrorField>
                </label>
                <Input
                  type="textarea"
                  label="Introduction"
                  placeholder="Introduction"
                  name="introduction"
                  value={localAgent.introduction ?? ""}
                  onChange={handleChange}
                />
                <label>
                  Identity <ErrorField>{formErrors.identity}</ErrorField>
                </label>
                <Input
                  type="textarea"
                  label="Identity"
                  placeholder="Identity"
                  name="identity"
                  value={localAgent.identity ?? ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!saving ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i> Saving...
                  </>
                ) : (
                  <>Save Changes</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

export default AddAgentModal;
